// import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import MainLayout from './Containers/MainLayout';


function App() {
  return (
    // <Provider store={store}>
      <Router>
        <MainLayout />
      </Router>
    // </Provider>
  );
}

export default App;
